export default __webpack_public_path__ + "68bdebb35d5a70fdaa25cfdfa6a6dd8b.woff2";